import MotionPathPlugin from "gsap/MotionPathPlugin"

export const getDistance = (
  from: any,
  to: any,
  fromParam: [number, number],
  toParam: [number, number]
) => {
  let distance = {
    x: 0,
    y: 0
  }

  const fromElem =
    typeof from === "string" ? document.querySelector(from) : from
  const toElem = typeof to === "string" ? document.querySelector(to) : to

  distance = MotionPathPlugin.getRelativePosition(
    fromElem,
    toElem,
    fromParam,
    toParam
  )

  // console.log(`distance | ${from} - ${to}`, distance)

  return distance
}
